import { ICalendarBusyTime } from '../../../interfaces/scheduler_interfaces';
import { CalendarTimesModel } from '../models/calendar_times_model';
import { IDefineCommand, ICommand, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
angular
  .module('capability-ng-scheduler')
  .service(
    'deleteStudentUnavailabilityCommand',
    (
      defineCommandORM: IDefineCommand,
      $http: ng.IHttpService,
      $state: ng.ui.IStateService,
      getUnscheduledSectionsandAvailabilityCommand: ICommand,
      $stateParams: ng.ui.IStateParamsService,
      QueryMediator: IQueryMediator,
      ngCalendarTimesModel: CalendarTimesModel
    ) => {
      return defineCommandORM('deleteStudentUnavailabilityCommand', (deferred, termId, timeId) => {
        if (!termId || !timeId) {
          deferred.reject();
          return;
        }

        $http
          .delete(`reg/preference/term/${termId}/unavailability/${timeId}`)
          .then(({ data }) => {
            // Filter out deleted time;
            const newBusyTimes = _4.filter(
              ngCalendarTimesModel.read().busy_times,
              (time: ICalendarBusyTime) => time.id !== timeId
            );
            const calendarSnapshot = ngCalendarTimesModel.read();
            ngCalendarTimesModel.clear().write({
              ...calendarSnapshot,
              busy_times: newBusyTimes
            });
            if ($state.is('my.schedule.registration.courseSections')) {
              const { sectionTypeId, courseId } = $stateParams;
              getUnscheduledSectionsandAvailabilityCommand(termId, courseId, sectionTypeId);
            }
            return deferred.resolve(data);
          })
          .catch((e) => {
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/calendar/commands/delete_student_unavailability_command.ts